import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-option',
  standalone: true,
  imports: [],
  templateUrl: './option.component.html',
  styleUrl: './option.component.css',
})
export class OptionComponent {
  @Input() isSelected: boolean = false;
  @Input() isValid: boolean = false; // When true, show red error styles
}
